import React from 'react';
import { Button } from '@themesberg/react-bootstrap';
import { Link } from 'react-router-dom';
import PermissionGate from '../components/PermissionGate';
import { PageAdminTable } from '../components/Tables';
import { isSuperAdmin, readSessionAdmin } from '../utils/userPermissions';

export default function Admin() {
  const superAdmin = isSuperAdmin(readSessionAdmin());

  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-3">
        <div className="my-auto">
          <h2 className="page-breadcrumb">{superAdmin ? 'Vendors' : 'User'}</h2>
        </div>

        <PermissionGate module="users" action="add">
          <Link to="/create-admin">
            <Button variant="primary" className="btn-quote-blue d-inline-flex align-items-center py-2 px-3 box-shedow-none outline-none">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-plus-circle me-1" aria-hidden="true">
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="8" x2="12" y2="16" />
                <line x1="8" y1="12" x2="16" y2="12" />
              </svg>
              {superAdmin ? 'Create Vendor' : 'Create User'}
            </Button>
          </Link>
        </PermissionGate>
      </div>

      <div className="my-auto">
        <PageAdminTable />
      </div>
    </>
  );
}
